/**
 * @file
 * Kit display renderers: tag, doc, image, media.
 */

((Drupal) => {
  const { berTags } = Drupal;
  const { components } = berTags;
  const { el } = berTags.dom;
  const ui = Drupal.berUI;
  const { base } = ui.compose;

  // Display components: the picked-value renderers. Like every factory,
  // each takes a single options object so ui.create() can build them.
  ui.display = {
    // A term-reference tag pill.
    tag: ({ item, meta, color, fill } = {}) =>
      base(components.tag(item, meta, color, fill)),

    // A file-shaped stand-in with a category-colored border and an
    // extension band; colors come from the hook-driven file-type map.
    doc: ({ ext = '', small = false } = {}) => {
      const doc = el(
        'span',
        small ? 'ber-media__doc ber-media__doc--small' : 'ber-media__doc',
      );
      const color = Drupal.berUpload.fileTypes.color(ext);
      if (color) {
        doc.style.setProperty('--ber-cat', color);
      }
      const band = el('span', 'ber-media__doc-ext');
      band.textContent = (ext || 'file').toUpperCase();
      doc.appendChild(band);
      return base(doc);
    },

    // An image thumbnail in the shared media box.
    image: ({ src, classes = '' } = {}) => {
      const box = el('div', `ber-upload__media ${classes}`.trim());
      if (src) {
        const img = el('img');
        img.src = src;
        img.alt = '';
        img.draggable = false;
        box.appendChild(img);
      }
      return base(box);
    },

    // A media thumbnail: real image when there is one, the doc shape for
    // plain files, a letter block as the last resort.
    media: (info, { classes = '' } = {}) => {
      const box = el('div', `ber-upload__media ${classes}`.trim());
      if (info.ext) {
        box.appendChild(ui.display.doc({ ext: info.ext }).el);
      } else if (info.thumbnail) {
        const img = el('img');
        img.src = info.thumbnail;
        img.alt = '';
        img.draggable = false;
        box.appendChild(img);
      } else {
        box.classList.add('ber-media__thumb--empty');
        box.textContent = (info.type || 'M').slice(0, 1);
      }
      return base(box);
    },
  };

  ui.register('display.tag', ui.display.tag);
  ui.register('display.doc', ui.display.doc);
  ui.register('display.image', ui.display.image);
  ui.register('display.media', ui.display.media);
})(Drupal);
